import { render, staticRenderFns } from "./CurriculumResources2.vue?vue&type=template&id=067efe50&scoped=true"
import script from "./CurriculumResources2.vue?vue&type=script&lang=js"
export * from "./CurriculumResources2.vue?vue&type=script&lang=js"
import style0 from "./CurriculumResources2.vue?vue&type=style&index=0&id=067efe50&prod&lang=less&scoped=true"
import style1 from "./CurriculumResources2.vue?vue&type=style&index=1&id=067efe50&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067efe50",
  null
  
)

export default component.exports